import type { PropsWithChildren, ReactNode } from 'react';
import styles from './StatRow.module.css';

export function StatRow({ children }: PropsWithChildren) {
  return <div className={styles.row}>{children}</div>;
}

interface StatProps {
  /** The big numeric/textual headline. Use <Em> for accent styling. */
  value: ReactNode;
  /** The supporting label below. */
  label: ReactNode;
  /** Optional citation footnote number, rendered as a superscript in the value. */
  citation?: number;
}

export function Stat({ value, label, citation }: StatProps) {
  return (
    <div className={styles.stat}>
      <div className={styles.value}>
        {value}
        {citation !== undefined && <sup className={styles.citation}>{citation}</sup>}
      </div>
      <div className={styles.label}>{label}</div>
    </div>
  );
}
